import { Menu } from '@headlessui/react';
import clsx from 'clsx';

import FlagFR from './images/fr.svg';
import FlagFR_1x1 from './images/fr_1x1.svg';
import FlagGB from './images/gb.svg';
import FlagGB_1x1 from './images/gb_1x1.svg';
import { locale, setLocale } from '../../services/translation/translation';

export const LocaleSwitch = () => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div className="flex items-center justify-center h-full">
        <Menu.Button className="border rounded-full overflow-hidden w-5 h-5 flex items-center justify-center">
          {locale === 'fr' ? (
            <img alt="Drapeau Français" src={FlagFR_1x1} />
          ) : (
            <img alt="English flag" src={FlagGB_1x1} />
          )}
        </Menu.Button>
      </div>
      <Menu.Items className="absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-background shadow-lg shadow-shadow border border-border focus:outline-none w-24">
        {locale !== 'fr' ? (
          <Menu.Item>
            {({ active }) => (
              <button
                className={clsx(
                  active ? 'bg-background_highlight' : '',
                  'group w-full flex items-center px-2 py-2 text-sm gap-x-2',
                )}
                onClick={() => {
                  {
                    setLocale('fr');
                  }
                }}
              >
                <img className="w-4" alt="Drapeau Français" src={FlagFR} />
                <p className="flex-1">Français</p>
              </button>
            )}
          </Menu.Item>
        ) : null}
        {locale !== 'en' ? (
          <Menu.Item>
            {({ active }) => (
              <button
                className={clsx(
                  active ? 'bg-background_highlight' : '',
                  'group w-full flex items-center px-2 py-2 text-sm gap-x-2',
                )}
                onClick={() => {
                  {
                    setLocale('en');
                  }
                }}
              >
                <img className="w-4" alt="Drapeau Français" src={FlagGB} /> English
              </button>
            )}
          </Menu.Item>
        ) : null}
      </Menu.Items>
    </Menu>
  );
};
